var link_viewer_default = {
  "fontElementMap": "TFT03",
  "link": "_5VzWt",
  "linkInEditor": "_5Kc-e",
  "linkInViewer": "lfO3I",
  "toolbarUrlContainer": "zGVCr",
  "toolbarUrl": "eWzyl",
  "toolbarUrlAnchor": "DKnT0"
};
export {
  link_viewer_default as default
};
//# sourceMappingURL=link-viewer-scss.js.map
